import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MomentPipe } from './moment.pipe';
import { BookingDetailComponent } from './booking-detail/booking-detail.component';
import { LoginComponent } from './login/login.component';
import { BookingsComponent } from './bookings/bookings.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { StudentInformationsComponent } from './student-informations/student-informations.component';
import { CreateBrugesBookingComponent } from './create-bruges-booking/create-bruges-booking.component';
import { VademecumDetailComponent } from './vademecum-detail/vademecum-detail.component';
import { NavigationComponent } from './navigation/navigation.component';
import { EditBookingVademecumComponent } from './edit-booking-vademecum/edit-booking-vademecum.component';
import { EditBookingComponent } from './edit-booking/edit-booking.component';
import { UserInfoComponent } from './user-info/user-info.component';
import { EditBookingDetailComponent } from './edit-booking-detail/edit-booking-detail.component';
import { EditBookingPictureComponent } from './edit-booking-picture/edit-booking-picture.component';
import { ViewBookingDetailComponent } from './view-booking-detail/view-booking-detail.component';
import { EditVademecumComponent } from './edit-vademecum/edit-vademecum.component';
import { MedicalInfoComponent } from './medical-info/medical-info.component';
import { EditMedicalInfoComponent } from './edit-medical-info/edit-medical-info.component';
import { EditSchoolInfoComponent } from './edit-school-info/edit-school-info.component';
import { PersonalInfoComponent } from './personal-info/personal-info.component';
import { SchoolInfoComponent } from './school-info/school-info.component';
import { JsonFilterPipe } from './pipe/json-filter.pipe';
import { BookingsDeletedComponent } from './bookings-deleted/bookings-deleted.component';
import { EditDeletedBookingDetailComponent } from './edit-deleted-booking-detail/edit-deleted-booking-detail.component';
import { BookingsCurrentComponent } from './bookings-current/bookings-current.component';
import { EmailTemplateComponent } from './email-template/email-template.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { SchoolsComponent } from './schools/schools.component';
import { SchoolEditComponent } from './school-edit/school-edit.component';
import { SchoolCreateComponent } from './school-create/school-create.component';
import { AutofillConfigComponent } from './autofill-config/autofill-config.component';
import { GuideEditComponent } from './guide-edit/guide-edit.component';
import { GuidesComponent } from './guides/guides.component';
import { GuideCreateComponent } from './guide-create/guide-create.component';
import { SummaryTextPipe } from './pipe/summary-text.pipe';
import { MyBookingsComponent } from './my-bookings/my-bookings.component';
import { EditBookingImmersionComponent } from './edit-booking-immersion/edit-booking-immersion.component';
import { TestServerDownComponent } from './test-server-down/test-server-down.component';
import { ErrorServerDownComponent } from './error-server-down/error-server-down.component';
import { AccountSettingComponent } from './account-setting/account-setting.component';
import { AllInvoicesComponent } from './all-invoices/all-invoices.component';
import { BookingAccommodationComponent } from './booking-accommodation/booking-accommodation.component';
import { BookingConfirmationPreviewComponent } from './booking-confirmation-preview/booking-confirmation-preview.component';
import { BookingConfirmationTemplateEditComponent } from './booking-confirmation-template-edit/booking-confirmation-template-edit.component';
import { BookingConfirmationTemplatesComponent } from './booking-confirmation-templates/booking-confirmation-templates.component';
import { BookingEmailTemplatesComponent } from './booking-email-templates/booking-email-templates.component';
import { BookingEmailComponent } from './booking-email/booking-email.component';
import { BookingFilesComponent } from './booking-files/booking-files.component';
import { BookingFinalConfirmationTemplateEditComponent } from './booking-final-confirmation-template-edit/booking-final-confirmation-template-edit.component';
import { BookingFinalConfirmationTemplatesComponent } from './booking-final-confirmation-templates/booking-final-confirmation-templates.component';
import { BookingPreConfirmationPreviewComponent } from './booking-pre-confirmation-preview/booking-pre-confirmation-preview.component';
import { BookingPreConfirmationTemplateEditComponent } from './booking-pre-confirmation-template-edit/booking-pre-confirmation-template-edit.component';
import { BookingPreConfirmationTemplatesComponent } from './booking-pre-confirmation-templates/booking-pre-confirmation-templates.component';
import { BookingPreConfirmationComponent } from './booking-pre-confirmation/booking-pre-confirmation.component';
import { BookingQuotationsComponent } from './booking-quotations/booking-quotations.component';
import { BookingReportPreviewComponent } from './booking-report-preview/booking-report-preview.component';
import { BookingStudentZoneComponent } from './booking-student-zone/booking-student-zone.component';
import { BookingStudentComponent } from './booking-student/booking-student.component';
import { BookingSummaryComponent } from './booking-summary/booking-summary.component';
import { BookingTransactionsComponent } from './booking-transactions/booking-transactions.component';
import { BookingsBrugesComponent } from './bookings-bruges/bookings-bruges.component';
import { BookingsEtcComponent } from './bookings-etc/bookings-etc.component';
import { BookingsSavedSearchesComponent } from './bookings-saved-searches/bookings-saved-searches.component';
import { BookingsWithUsersComponent } from './bookings-with-users/bookings-with-users.component';
import { CloneBookingQuotationComponent } from './clone-booking-quotation/clone-booking-quotation.component';
import { CloneContactRequestQuotationComponent } from './clone-contact-request-quotation/clone-contact-request-quotation.component';
import { ContactRequestEditNavigationComponent } from './contact-request-edit-navigation/contact-request-edit-navigation.component';
import { ContactRequestQuotationPreviewComponent } from './contact-request-quotation-preview/contact-request-quotation-preview.component';
import { ContactRequestQuotationsComponent } from './contact-request-quotations/contact-request-quotations.component';
import { CreateBookingEmailTemplateComponent } from './create-booking-email-template/create-booking-email-template.component';
import { CreateBookingPreConfirmationComponent } from './create-booking-pre-confirmation/create-booking-pre-confirmation.component';
import { CreateBookingQuotationComponent } from './create-booking-quotation/create-booking-quotation.component';
import { CreateBookingComponent } from './create-booking/create-booking.component';
import { CreateBulkInvoicesComponent } from './create-bulk-invoices/create-bulk-invoices.component';
import { CreateContactRequestQuotationComponent } from './create-contact-request-quotation/create-contact-request-quotation.component';
import { CreateContactRequestComponent } from './create-contact-request/create-contact-request.component';
import { CreateEtcBookingComponent } from './create-etc-booking/create-etc-booking.component';
import { CreateLeadEmailTemplateComponent } from './create-lead-email-template/create-lead-email-template.component';
import { CreatePaymentReceivedComponent } from './create-payment-received/create-payment-received.component';
import { CreatePaymentToSupplierComponent } from './create-payment-to-supplier/create-payment-to-supplier.component';
import { CreateQuotationTemplateComponent } from './create-quotation-template/create-quotation-template.component';
import { CreateSalesInvoiceComponent } from './create-sales-invoice/create-sales-invoice.component';
import { CreateSchoolInvoiceComponent } from './create-school-invoice/create-school-invoice.component';
import { CreateSingleBookingComponent } from './create-single-booking/create-single-booking.component';
import { CreateWpContactRequestPdfTemplateComponent } from './create-wp-contact-request-pdf-template/create-wp-contact-request-pdf-template.component';
import { DashboardGeneralClientComponent } from './dashboard-general-client/dashboard-general-client.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { EditBookingBrugesVndComponent } from './edit-booking-bruges-vnd/edit-booking-bruges-vnd.component';
import { EditBookingBrugesComponent } from './edit-booking-bruges/edit-booking-bruges.component';
import { EditBookingDetailEtcComponent } from './edit-booking-detail-etc/edit-booking-detail-etc.component';
import { EditBookingEmailTemplateComponent } from './edit-booking-email-template/edit-booking-email-template.component';
import { EditBookingHighSchoolComponent } from './edit-booking-high-school/edit-booking-high-school.component';
import { EditContactRequestComponent } from './edit-contact-request/edit-contact-request.component';
import { EditInternalBookingCommentComponent } from './edit-internal-booking-comment/edit-internal-booking-comment.component';
import { EditLeadEmailTemplateComponent } from './edit-lead-email-template/edit-lead-email-template.component';
import { EditPaymentReceivedComponent } from './edit-payment-received/edit-payment-received.component';
import { EditPaymentToSupplierComponent } from './edit-payment-to-supplier/edit-payment-to-supplier.component';
import { EditPdfTemplateCssComponent } from './edit-pdf-template-css/edit-pdf-template-css.component';
import { EditQuotationTemplateComponent } from './edit-quotation-template/edit-quotation-template.component';
import { EditSchoolInvoiceFileComponent } from './edit-school-invoice-file/edit-school-invoice-file.component';
import { EditSchoolInvoiceComponent } from './edit-school-invoice/edit-school-invoice.component';
import { EditWpContactRequestPdfTemplateComponent } from './edit-wp-contact-request-pdf-template/edit-wp-contact-request-pdf-template.component';
import { EmailSendingSpinnerComponent } from './email-sending-spinner/email-sending-spinner.component';
import { ErrorApiExceptionComponent } from './error-api-exception/error-api-exception.component';
import { EtcParentalPermissionComponent } from './etc-parental-permission/etc-parental-permission.component';
import { GlobalBookingFilesComponent } from './global-booking-files/global-booking-files.component';
import { GlobalNotificationComponent } from './global-notification/global-notification.component';
import { GroupBookingCreateComponent } from './group-booking-create/group-booking-create.component';
import { GroupBookingDetailComponent } from './group-booking-detail/group-booking-detail.component';
import { GroupBookingsComponent } from './group-bookings/group-bookings.component';
import { LastUpdatesComponent } from './last-updates/last-updates.component';
import { LeadEmailTemplatesComponent } from './lead-email-templates/lead-email-templates.component';
import { LeadsComponent } from './leads/leads.component';
import { LinkItemCreateComponent } from './link-item-create/link-item-create.component';
import { LinkItemsManageComponent } from './link-items-manage/link-items-manage.component';
import { LinksComponent } from './links/links.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LvmsBookingCreateComponent } from './lvms-booking-create/lvms-booking-create.component';
import { Oauth2SuccessComponent } from './oauth2-success/oauth2-success.component';
import { OnlineCourseCreateComponent } from './online-course-create/online-course-create.component';
import { OnlineCoursesComponent } from './online-courses/online-courses.component';
import { PaymentsReceivedComponent } from './payments-received/payments-received.component';
import { PdfDocumentHeaderFooterEditComponent } from './pdf-document-header-footer-edit/pdf-document-header-footer-edit.component';
import { PdfDocumentHeadersComponent } from './pdf-document-headers/pdf-document-headers.component';
import { PdfTemplateCreateComponent } from './pdf-template-create/pdf-template-create.component';
import { PdfTemplateCssesComponent } from './pdf-template-csses/pdf-template-csses.component';
import { PdfTemplateEditComponent } from './pdf-template-edit/pdf-template-edit.component';
import { PdfTemplateNavigationComponent } from './pdf-template-navigation/pdf-template-navigation.component';
import { PdfTemplatesBookingRelatedComponent } from './pdf-templates-booking-related/pdf-templates-booking-related.component';
import { PdfTemplatesHeaderFooterComponent } from './pdf-templates-header-footer/pdf-templates-header-footer.component';
import { PdfTemplatesLeadRelatedComponent } from './pdf-templates-lead-related/pdf-templates-lead-related.component';
import { DecimalAmountPipe } from './pipe/decimal-amount.pipe';
import { DecimalCeilingPipe } from './pipe/decimal-ceiling.pipe';
import { FileSizePipe } from './pipe/file-size.pipe';
import { IdToNamePipe } from './pipe/id-to-name.pipe';
import { ShortStrPipe } from './pipe/short-str.pipe';
import { ProgrammesComponent } from './programmes/programmes.component';
import { PromotionCreateComponent } from './promotion-create/promotion-create.component';
import { PromotionEditComponent } from './promotion-edit/promotion-edit.component';
import { PromotionsComponent } from './promotions/promotions.component';
import { PublicFooterComponent } from './public-footer/public-footer.component';
import { QuotationTemplatesComponent } from './quotation-templates/quotation-templates.component';
import { RefundRequestCreateComponent } from './refund-request-create/refund-request-create.component';
import { RefundRequestEditComponent } from './refund-request-edit/refund-request-edit.component';
import { RefundRequestsComponent } from './refund-requests/refund-requests.component';
import { SalesInvoiceDetailComponent } from './sales-invoice-detail/sales-invoice-detail.component';
import { SalesInvoicesComponent } from './sales-invoices/sales-invoices.component';
import { SalesProductTypePipe } from './sales-product-type.pipe';
import { SchoolBookingsComponent } from './school-bookings/school-bookings.component';
import { SchoolContactEditComponent } from './school-contact-edit/school-contact-edit.component';
import { SchoolCourseEditComponent } from './school-course-edit/school-course-edit.component';
import { SchoolDocumentFileEditComponent } from './school-document-file-edit/school-document-file-edit.component';
import { SchoolEditNavigationComponent } from './school-edit-navigation/school-edit-navigation.component';
import { SchoolFileUploadComponent } from './school-file-upload/school-file-upload.component';
import { SchoolQuotationTemplatesComponent } from './school-quotation-templates/school-quotation-templates.component';
import { SchoolUrlEditComponent } from './school-url-edit/school-url-edit.component';
import { SiepSalonContactsComponent } from './siep-salon-contacts/siep-salon-contacts.component';
import { SimpleBookingStatsComponent } from './simple-booking-stats/simple-booking-stats.component';
import { SalesReportFirstTabComponent } from './stats/sales-report/sales-report-first-tab/sales-report-first-tab.component';
import { SalesReportSecondTabComponent } from './stats/sales-report/sales-report-second-tab/sales-report-second-tab.component';
import { SalesReportComponent } from './stats/sales-report/sales-report.component';
import { StripWpTagsComponent } from './strip-wp-tags/strip-wp-tags.component';
import { StudentCreateComponent } from './student-create/student-create.component';
import { StudentEditComponent } from './student-edit/student-edit.component';
import { StudentsComponent } from './students/students.component';
import { SystemUserCreateComponent } from './system-user-create/system-user-create.component';
import { SystemUserEditComponent } from './system-user-edit/system-user-edit.component';
import { SystemUsersComponent } from './system-users/system-users.component';
import { TestGmailApiComponent } from './test-gmail-api/test-gmail-api.component';
import { TestVivawalletComponent } from './test-vivawallet/test-vivawallet.component';
import { TransactionsPaymentReceivedComponent } from './transactions-payment-received/transactions-payment-received.component';
import { TransactionsSchoolInvoiceComponent } from './transactions-school-invoice/transactions-school-invoice.component';
import { TransactionsVatReportComponent } from './transactions-vat-report/transactions-vat-report.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { TravelCreateComponent } from './travel-create/travel-create.component';
import { TravelEditComponent } from './travel-edit/travel-edit.component';
import { TravelsComponent } from './travels/travels.component';
import { VivawalletErrorComponent } from './vivawallet-error/vivawallet-error.component';
import { VivawalletPaymentOrdersComponent } from './vivawallet-payment-orders/vivawallet-payment-orders.component';
import { VivawalletSuccessComponent } from './vivawallet-success/vivawallet-success.component';
import { WpBookingRequestEditComponent } from './wp-booking-request-edit/wp-booking-request-edit.component';
import { WpBookingRequestPrintComponent } from './wp-booking-request-print/wp-booking-request-print.component';
import { WpBookingRequestsComponent } from './wp-booking-requests/wp-booking-requests.component';
import { WpContactRequestsComponent } from './wp-contact-requests/wp-contact-requests.component';
import { ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { CalendarModule } from 'primeng/calendar';
import { AccordionModule } from 'primeng/accordion';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DragDropModule } from 'primeng/dragdrop';
import { MenuModule } from 'primeng/menu';
import { MenuItem, ConfirmationService, MessageService } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { FileUploadModule } from 'primeng/fileupload';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabMenuModule } from 'primeng/tabmenu';
import { StepsModule } from 'primeng/steps';
import { FormControlPipe } from './pipe/form-control.pipe';
import { FormGroupPipe } from './pipe/form-group.pipe';
import { UserService } from './service/user.service';
import { AuthenticatedHttpClient } from './authenticated-http-client';
import { ConnectedGuardService } from './security/connected-guard.service';
import { KeycloakAuthService } from './security/keycloak-auth.service';
import { LeadQuotationService } from './service/lead-quotation.service';
import { ContactRequestService } from './service/contact-request.service';
import { HttpService } from './service/http.service';
import { ChipModule } from 'primeng/chip';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { TransactionsPaymentToSchoolComponent } from './transactions-payment-to-school/transactions-payment-to-school.component';
import { MyInvoicesComponent } from './my-invoices/my-invoices.component';
import { PaymentRemindersComponent } from './payment-reminders/payment-reminders.component';
import { SalesReportThirdTabComponent } from './stats/sales-report/sales-report-third-tab/sales-report-third-tab.component';
import { SalesReportHighschoolComponent } from './stats/sales-report/sales-report-highschool/sales-report-highschool.component';
import { SalesReportEnglishMarketComponent } from './stats/sales-report/sales-report-english-market/sales-report-english-market.component';
import { CreateAviInvoiceComponent } from './accounting/create-avi-invoice/create-avi-invoice.component';
import { AviInvoicesComponent } from './accounting/avi-invoices/avi-invoices.component';
import { SalesReportAllAgentsComponent } from './stats/sales-report/sales-report-all-agents/sales-report-all-agents.component';
import { ConstantContactComponent } from './constant-contact/constant-contact.component';
import { ConstantContactCampaignDetailComponent } from './constant-contact-campaign-detail/constant-contact-campaign-detail.component';
import { AgentCommissionComponent } from './agent-commission/agent-commission.component';
import { SchoolInvoicesToValidateComponent } from './school-invoices-to-validate/school-invoices-to-validate.component';
import { AgentCommissionsUpdateComponent } from './agent-commissions-update/agent-commissions-update.component';
import { AgentCommissionCreatePaymentComponent } from './agent-commission-create-payment/agent-commission-create-payment.component';
import { InvoicesComponent } from './general-supplier-invoice/invoices/invoices.component';
import { UnpaidInvoicesComponent } from './general-supplier-invoice/unpaid-invoices/unpaid-invoices.component';
import { CreatePaidInvoiceComponent } from './general-supplier-invoice/create-paid-invoice/create-paid-invoice.component';
import { CreateUnpaidInvoiceComponent } from './general-supplier-invoice/create-unpaid-invoice/create-unpaid-invoice.component';
import { MenubarModule } from 'primeng/menubar';
import { EditUnpaidInvoiceComponent } from './general-supplier-invoice/edit-unpaid-invoice/edit-unpaid-invoice.component';
import { RedirectingComponent } from './redirecting/redirecting.component';
import { AuthInterceptorService } from './security/auth-interceptor.service';

// import { CaptchaModule } from 'primeng/captcha';

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    MomentPipe,
    BookingDetailComponent,
    LoginComponent,
    BookingsComponent,
    NotFoundComponent,
    StudentInformationsComponent,
    CreateBrugesBookingComponent,
    VademecumDetailComponent,
    NavigationComponent,
    UserInfoComponent,
    EditBookingComponent,
    EditBookingDetailComponent,
    EditBookingPictureComponent,
    ViewBookingDetailComponent,
    EditBookingVademecumComponent,
    EditVademecumComponent,
    EditMedicalInfoComponent,
    EditSchoolInfoComponent,
    PersonalInfoComponent,
    MedicalInfoComponent,
    SchoolInfoComponent,
    JsonFilterPipe,
    BookingsDeletedComponent,
    EditDeletedBookingDetailComponent,
    BookingsCurrentComponent,
    EmailTemplateComponent,
    SafeHtmlPipe,
    SchoolsComponent,
    SchoolEditComponent,
    SchoolCreateComponent,
    AutofillConfigComponent,
    GuidesComponent,
    GuideCreateComponent,
    GuideEditComponent,
    SummaryTextPipe,
    PromotionsComponent,
    PromotionCreateComponent,
    PromotionEditComponent,
    CreateEtcBookingComponent,
    EtcParentalPermissionComponent,
    BookingsEtcComponent,
    EditBookingDetailEtcComponent,
    LinkItemCreateComponent,
    LinksComponent,
    LinkItemsManageComponent,
    OnlineCoursesComponent,
    OnlineCourseCreateComponent,
    AccountSettingComponent,
    StripWpTagsComponent,
    SystemUsersComponent,
    SystemUserEditComponent,
    SystemUserCreateComponent,
    RefundRequestCreateComponent,
    RefundRequestsComponent,
    RefundRequestEditComponent,
    EditBookingBrugesComponent,
    DatepickerComponent,
    PdfTemplateCreateComponent,
    PdfTemplateEditComponent,
    WpBookingRequestsComponent,
    WpBookingRequestEditComponent,
    WpBookingRequestPrintComponent,
    LvmsBookingCreateComponent,
    WpContactRequestsComponent,
    BookingsBrugesComponent,
    TravelCreateComponent,
    TravelsComponent,
    TravelEditComponent,
    StudentsComponent,
    StudentCreateComponent,
    StudentEditComponent,
    BookingReportPreviewComponent,
    PaymentsReceivedComponent,
    EditPdfTemplateCssComponent,
    EditBookingBrugesVndComponent,
    CreateBookingQuotationComponent,
    CreateContactRequestQuotationComponent,
    CloneContactRequestQuotationComponent,
    CreateWpContactRequestPdfTemplateComponent,
    EditWpContactRequestPdfTemplateComponent,
    BookingQuotationsComponent,
    CloneBookingQuotationComponent,
    CreateContactRequestComponent,
    EditContactRequestComponent,
    CreateQuotationTemplateComponent,
    QuotationTemplatesComponent,
    EditQuotationTemplateComponent,
    SiepSalonContactsComponent,
    CreateSalesInvoiceComponent,
    SalesInvoicesComponent,
    SalesInvoiceDetailComponent,
    PdfDocumentHeadersComponent,
    PdfDocumentHeaderFooterEditComponent,
    PdfTemplateCssesComponent,
    CreateLeadEmailTemplateComponent,
    LeadEmailTemplatesComponent,
    EditLeadEmailTemplateComponent,
    SchoolDocumentFileEditComponent,
    SchoolEditNavigationComponent,
    LastUpdatesComponent,
    SchoolContactEditComponent,
    SchoolFileUploadComponent,
    SchoolUrlEditComponent,
    GlobalBookingFilesComponent,
    FileSizePipe,
    CreateBookingEmailTemplateComponent,
    BookingEmailTemplatesComponent,
    EditBookingEmailTemplateComponent,
    ContactRequestEditNavigationComponent,
    SimpleBookingStatsComponent,
    CreateBookingPreConfirmationComponent,
    BookingPreConfirmationTemplatesComponent,
    BookingPreConfirmationTemplateEditComponent,
    TestGmailApiComponent,
    AllInvoicesComponent,
    SalesProductTypePipe,
    IdToNamePipe,
    TransactionsComponent,
    TransactionsPaymentReceivedComponent,
    TransactionsVatReportComponent,
    ContactRequestQuotationsComponent,
    ContactRequestQuotationPreviewComponent,
    ProgrammesComponent,
    LeadsComponent,
    PdfTemplateNavigationComponent,
    PdfTemplatesBookingRelatedComponent,
    PdfTemplatesLeadRelatedComponent,
    PdfTemplatesHeaderFooterComponent,
    BookingPreConfirmationPreviewComponent,
    CreateSchoolInvoiceComponent,
    EditSchoolInvoiceComponent,
    CreatePaymentToSupplierComponent,
    EditPaymentToSupplierComponent,
    CreatePaymentReceivedComponent,
    EditPaymentReceivedComponent,
    BookingStudentZoneComponent,
    DashboardGeneralClientComponent,
    EmailSendingSpinnerComponent,
    SchoolCourseEditComponent,
    GlobalNotificationComponent,
    BookingFilesComponent,
    BookingConfirmationPreviewComponent,
    BookingTransactionsComponent,
    BookingPreConfirmationComponent,
    BookingAccommodationComponent,
    BookingStudentComponent,
    BookingSummaryComponent,
    BookingEmailComponent,
    BookingFinalConfirmationTemplatesComponent,
    BookingFinalConfirmationTemplateEditComponent,
    BookingConfirmationTemplatesComponent,
    BookingConfirmationTemplateEditComponent,
    LoadingSpinnerComponent,
    BookingsSavedSearchesComponent,
    DecimalAmountPipe,
    ShortStrPipe,
    EditInternalBookingCommentComponent,
    CreateBulkInvoicesComponent,
    TransactionsSchoolInvoiceComponent,
    Oauth2SuccessComponent,
    BookingsWithUsersComponent,
    DecimalCeilingPipe,
    EditSchoolInvoiceFileComponent,
    GroupBookingCreateComponent,
    GroupBookingsComponent,
    GroupBookingDetailComponent,
    CreateBookingComponent,
    CreateSingleBookingComponent,
    TestVivawalletComponent,
    VivawalletSuccessComponent,
    VivawalletErrorComponent,
    VivawalletPaymentOrdersComponent,
    SalesReportComponent,
    SalesReportFirstTabComponent,
    SalesReportSecondTabComponent,
    PublicFooterComponent,
    SchoolQuotationTemplatesComponent,
    SchoolBookingsComponent,
    EditBookingHighSchoolComponent,
    EditBookingImmersionComponent,
    TestServerDownComponent,
    ErrorServerDownComponent,
    ErrorApiExceptionComponent,
    MyBookingsComponent,
    FormControlPipe,
    FormGroupPipe,
    TransactionsPaymentToSchoolComponent,
    MyInvoicesComponent,
    PaymentRemindersComponent,
    SalesReportThirdTabComponent,
    SalesReportHighschoolComponent,
    SalesReportEnglishMarketComponent,
    CreateAviInvoiceComponent,
    AviInvoicesComponent,
    SalesReportAllAgentsComponent,
    ConstantContactComponent,
    ConstantContactCampaignDetailComponent,
    AgentCommissionComponent,
    SchoolInvoicesToValidateComponent,
    AgentCommissionsUpdateComponent,
    AgentCommissionCreatePaymentComponent,
    InvoicesComponent,
    UnpaidInvoicesComponent,
    CreatePaidInvoiceComponent,
    CreateUnpaidInvoiceComponent,
    EditUnpaidInvoiceComponent,
    RedirectingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: "XSRF-TOKEN",
      headerName: "X-XSRF-TOKEN"
    }),
    CalendarModule,
    AccordionModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    ButtonModule,
    ToastModule,
    RadioButtonModule,
    PaginatorModule,
    ConfirmDialogModule,
    DialogModule,
    CheckboxModule,
    TableModule,
    SelectButtonModule,
    DragDropModule,
    MenuModule,
    ProgressSpinnerModule,
    TooltipModule,
    InputNumberModule,
    ListboxModule,
    TabMenuModule,
    FileUploadModule,
    CardModule,
    MultiSelectModule,
    ChartModule,
    StepsModule,
    // CaptchaModule,
    InputSwitchModule,
    ChipModule,
    CKEditorModule,
    MenubarModule
  ],
  providers: [
    UserService,
    MessageService,
    ConnectedGuardService,
    AuthenticatedHttpClient,
    ConfirmationService,
    LeadQuotationService,
    ContactRequestService,
    HttpService,
    KeycloakAuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }